import React from 'react'
import clsx from 'clsx'
import { useEnvironment } from '@hooks/useEnvironment'
import styles from './styles/Loader.module.scss'
import { SVGIcon, svgIconExists } from '../SVGIcon/SVGIcon'
import { LoaderIcon } from '../SVGIcon/types/SVGIcon.types'

type LoaderProps = {
  variant?: 'light' | 'dark'
  open?: boolean // default is true
  size?: 'default' | 'large' | 'extra-large'
  className?: string
}

/**
 * Simple loader with brand specific svg support
 */
export const Loader: React.FC<LoaderProps> = props => {
  const { open = true, size, variant = 'light', className } = props
  const { brand } = useEnvironment()

  let svgIconName = `loader-${brand}-${variant}`
  if (!svgIconExists(svgIconName)) {
    svgIconName = `loader-base-${variant}`
  }

  return (
    <span
      className={clsx(
        svgIconName ? styles.svgLoader : styles.loader,
        styles[variant],
        open && styles.open,
        size && styles[size],
        className
      )}
    >
      {svgIconName && <SVGIcon library="loaders" name={svgIconName as LoaderIcon} />}
    </span>
  )
}

interface LoaderWithBackdropProps {
  loaderVariant?: LoaderProps['variant']
  open?: boolean // defaults to false
  backdropOnly?: boolean
}

/**
 * Loader with backdrop to block input
 */
export const LoaderWithBackdrop: React.FC<LoaderWithBackdropProps> = props => {
  const { open, loaderVariant, backdropOnly } = props

  return (
    <div className={clsx(styles.backdrop, open && styles.open)}>
      <Loader variant={loaderVariant} open={open && !backdropOnly} size="large" />
    </div>
  )
}

type GlasspaneProps = {
  open?: boolean // defaults to false
}

/**
 * Glasspane to block input
 */
export const Glasspane: React.FC<GlasspaneProps> = props => {
  const { open } = props

  return <div className={clsx(styles.backdrop, styles.glasspane, open && styles.open)}></div>
}
